import { z } from "zod";
import { BusinessGraphFactProvenanceV1Schema } from "./business-graph-provenance.js";
/** Unified BG-004 review actions (mirrors import confirmation kinds + clarify-with-reason). */
export const BusinessGraphCandidateReviewActionV1Schema = z.enum([
    "VERIFY",
    "REJECT",
    "EDIT",
    "CLARIFY_WITH_REASON",
]);
export const BusinessGraphCandidateReviewRequestV1Schema = z
    .object({
    schemaId: z.literal("businessgraph.candidateReview.v1"),
    fieldPath: z.string().min(1),
    action: BusinessGraphCandidateReviewActionV1Schema,
    /** Required for CLARIFY_WITH_REASON; optional notes for REJECT. */
    reason: z.string().min(1).max(2000).optional(),
    /** Required for EDIT — replacement scalar/array JSON value for supported paths. */
    editedValue: z.unknown().optional(),
    actorId: z.string().min(1).optional(),
    reviewedAt: z.string().datetime().optional(),
})
    .strict();
export const BusinessGraphCandidateReviewResultV1Schema = z
    .object({
    schemaId: z.literal("businessgraph.candidateReviewResult.v1"),
    fieldPath: z.string().min(1),
    action: BusinessGraphCandidateReviewActionV1Schema,
    provenance: BusinessGraphFactProvenanceV1Schema,
})
    .strict();
//# sourceMappingURL=business-graph-candidate-review.js.map